import React from 'react';
import ProductHeaderDesktop from './components/header-desktop';
import { ProductHeaderMobile } from './components/header-mobile';
import { ProductHeaderProps } from './types';
import Viewport from '../../../../components/viewport';
import { Price } from 'src/types';
import { createOfferFromPriceItem } from '../price-list/utils';

export const ProductHeader = React.memo((props: ProductHeaderProps) => {
  const ourChoice = props.product?.prices?.ourChoice as Price;
  const ourChoiceOffer = ourChoice && createOfferFromPriceItem(ourChoice);
  const ourChoiceProps = { ourChoice, ourChoiceOffer };

  return (
    <>
      <Viewport desktop tablet>
        <ProductHeaderDesktop {...props} {...ourChoiceProps} />
      </Viewport>
      <Viewport mobile>
        <ProductHeaderMobile {...props} {...ourChoiceProps} />
      </Viewport>
    </>
  );
});
